import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { map, catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { FloorPlanModel } from '../models/floor-plan.model';

@Injectable({
  providedIn: 'root'
})
export class FloorPlanService {

  constructor(private http: HttpClient, private config: ConfigService) { }

  public GetFloorPlans(): Observable<Array<FloorPlanModel>> {
    return this.http.get<Array<FloorPlanModel>>(this.config.getApiRoute('api/v3/client-portal/floor-plans')).pipe(
        map(data => {
            return data;
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err.error.message);
        }));
    }
}